export const LOAD: 'TRACKING_DESCRIPTION/LOAD' = 'TRACKING_DESCRIPTION/LOAD';
export const LOAD_SUCCESS: 'TRACKING_DESCRIPTION/LOAD_SUCCESS' = 'TRACKING_DESCRIPTION/LOAD_SUCCESS';
export const LOAD_FAILURE: 'TRACKING_DESCRIPTION/LOAD_FAILURE' = 'TRACKING_DESCRIPTION/LOAD_FAILURE';
export const OPEN: 'TRACKING_DESCRIPTION/OPEN' = 'TRACKING_DESCRIPTION/OPEN';
export const CLOSE: 'TRACKING_DESCRIPTION/CLOSE' = 'TRACKING_DESCRIPTION/CLOSE';
